import moment from 'moment';
import { DATE_FORMAT } from '../calendar/consts';

export enum BillAgeType {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  DAYS_AGO = 'days_ago',
}

export type BillAge = { type: BillAgeType; days: number };

export const BILL_AGE_COLORS: Record<BillAgeType, { fill: string; ink: string }> = {
  [BillAgeType.TODAY]: { fill: 'mb.lineSoft', ink: 'mb.ink' },
  [BillAgeType.YESTERDAY]: { fill: 'mb.claySoft', ink: 'mb.clayInk' },
  [BillAgeType.DAYS_AGO]: { fill: 'mb.dangerSoft', ink: 'mb.danger' },
};

export const billAge = (date: string, accountToday: string): BillAge => {
  const days = Math.max(moment(accountToday, DATE_FORMAT).diff(moment(date, DATE_FORMAT), 'days'), 0);
  if (days === 0) {
    return { type: BillAgeType.TODAY, days };
  }
  return { type: days === 1 ? BillAgeType.YESTERDAY : BillAgeType.DAYS_AGO, days };
};
